/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var Z63 = (function (parent, $) {

	    var MediaQueryListener = function() {
	        this.afterElement = window.getComputedStyle ? window.getComputedStyle(document.body, ':after') : false;
	        this.currentBreakpoint = '';
	        this.lastBreakpoint = '';
	        this.init();
	    };

	    MediaQueryListener.prototype = {

	        init: function () {
	            var self = this;

	            if(!self.afterElement) {
	                return;
	            }

	            self._resizeListener();

	        },
	        _resizeListener: function () {
	            var self = this;

	            $(window).on('resize orientationchange load', function() {
	                // Regexp for removing quotes added by various browsers
	                self.currentBreakpoint = self.afterElement.getPropertyValue('content').replace(/^["']|["']$/g, '');

	                if (self.currentBreakpoint !== self.lastBreakpoint) {
	                    $(window).trigger('breakpoint-change', self.currentBreakpoint);
	                    self.lastBreakpoint = self.currentBreakpoint;
	                }

	            });
	        }

	    };

	    parent.mediaqueryListener = parent.mediaqueryListener || new MediaQueryListener();

	    return parent;

	}(Z63 || {}, jQuery));

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        var inMinute = new Date(new Date().getTime() + 60 * 60 * 24 * 10 * 1000); //2592000000
        var pageMenuTop = 0;

      	var getUrlParameter = function getUrlParameter(sParam) {
      	    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      	        sURLVariables = sPageURL.split('&'),
      	        sParameterName,
      	        i;

      	    for (i = 0; i < sURLVariables.length; i++) {
      	        sParameterName = sURLVariables[i].split('=');

      	        if (sParameterName[0] === sParam) {
      	            return sParameterName[1] === undefined ? true : sParameterName[1];
      	        }
      	    }
      	};

        $(document).on('click', '.wpcf7-submit', function(e){
    			if( $('.ajax-loader').css('visibility') == 'visible' ) {
              e.preventDefault();
              return false;
           }
        });



        // cookies TODO
        /*vanhafunction getCookie(cookieName) {
      		var theCookie=" "+document.cookie;
      		var ind=theCookie.indexOf(" "+cookieName+"=");
      		if (ind==-1) ind=theCookie.indexOf(";"+cookieName+"=");
      		if (ind==-1 || cookieName==="") return "";
      		var ind1=theCookie.indexOf(";",ind+1);
      		if (ind1==-1) ind1=theCookie.length;
      		return unescape(theCookie.substring(ind+cookieName.length+2,ind1));
      	}
        */

        // menu functions
        $('.footer-products .menu-item-has-children > a').on('click', function(e) {
          $(this).parent().toggleClass('hover');
          e.preventDefault();
          e.stopPropagation();
        });
        $('body').on('click', function() {
          $('.footer-products .menu-item-has-children').removeClass('hover');
        });
        function toggleNav(e){
      		if ( !$('.main-nav').hasClass('open') ) {

      			$('.main-nav').addClass('open');
      			$('body').css('overflow-y', 'hidden');
      		} else {
      			closeNav(e);
      		}
      		e.stopPropagation();
      		e.preventDefault();
      	}
      	function closeNav(e) {
      		if ( $('.main-nav').hasClass('open') ) {

      			$('.main-nav').removeClass('open');
      			$('.main-nav').removeClass('level-0-open');
      			$('body').css('overflow-y', 'auto');
      		}
      		e.preventDefault();
      	}
      	function fixedHeader() {
      		if ( $(window).scrollTop() > 28 ) {
      			$('body').addClass('scrolled');
      		} else {
      			$('body').removeClass('scrolled');
      		}
      	}


      	/*function fixedPagemenu() {
      		if ( !$('body').hasClass('mobile') && matchMedia('(min-width: 769px)').matches ) {
      			if ( $(window).scrollTop() > pageMenuTop - 70 ) {
      				$('.page-menu-container').addClass('fixed');
      				$('.page-menu-container').next().css('marginTop', $('.page-menu').height());
      			} else {
      				$('.page-menu-container').removeClass('fixed');
      				$('.page-menu-container').next().css('marginTop',0);
      			}
      		}

      	}*/
      	function toggleNavOverlay(e){
      		if ( !$('.nav-overlay').hasClass('open') ) {

      			$('.nav-overlay').addClass('open');
      		} else {
      			closeNavOverlay();
      		}
      		e.stopPropagation();
      		e.preventDefault();
      	}
      	function closeNavOverlay(e) {
      		if ( $('.nav-overlay').hasClass('open') ) {

      			$('.nav-overlay').removeClass('open');
      		}
      		e.preventDefault();
      	}

        // Disable ancestor-styles for submenu items where disable current ise selected
        $('.ubermenu-item-level-0.ubermenu-current-menu-ancestor').each(function() {
          if ( $(this).find('.ubermenu-current_page_item').hasClass('ubermenu-nocurrent') ) {
            $(this).removeClass('ubermenu-current-menu-ancestor');
          }
        });


        // JavaScript to be fired on all pages TODO
        if ( $('body').hasClass('dev') ) {
      		window['ga-disable-UA-2407578-13'] = true;
      	}


        /* in page links */
        $('a[href*="#"]:not([href="#"]):not([href="#contactform"]):not(".js-noinpage")').click(function() {
    			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    				var target = $(this.hash);
    				var menuoffset = $('.main-nav').height();
    				if ( $(this).parent().parent().parent().hasClass('page-menu') && $(window).width() > 768 ) {
    					menuoffset += $(this).parent().parent().parent().height();
    				} else {
    					menuoffset = 0;
    				}
    				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    				if (target.length) {
    					$('html,body').animate({
    					  scrollTop: target.offset().top - menuoffset
    					}, 1000);
    					return false;
    				}
    			}
    		});

        // TODO
    		/*$('.movie, .js-movie').click(function(e) {
    			e.preventDefault();
    			var url = this.href;
    			$.fancybox({
    				'href' : url,
    				'openEffect'	: 'elastic',
    				'closeEffect'	: 'elastic',
    				'padding'		: '0',
    				'closeBtn'		: true,
    				'autoCenter'	: true,
    				'type'			: 'iframe',
    				'aspectRatio'	: true,
    				'width'			: 800,
    				'height'		: 450

    			});
    		});*/

        // goto selected link from select input field
        $('.link-select').on('change', function() {
          var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
          if(!pattern.test($(this).val())) {
            return false;
          } else {
            window.location.href = $(this).val();
            //window.open($(this).val());
            return true;
          }
        });






        // add icons to specific link types

        // Add double arrows to menu links
        //$('.main-nav .ubermenu-retractor-mobile, .main-nav li.ubermenu-has-submenu-drop > .ubermenu-target').append('<svg class="menu-arrow"><use xlink:href="#double-arrow"></use></svg>');

        //$('.top-nav li.ubermenu-has-submenu-drop > .ubermenu-target').prepend('<svg class="menu-arrow"><use xlink:href="#language"></use></svg>');

        // add triangle arrow svg to all content links. Remove later for specific link types
        //$('.section-content a:not(.button)').append('<svg class="icon-link"><use xlink:href="#play_arrow"></use></svg>');
        $('.section-content a:not(.button)').append('<span class="linkarrow"> &#8250;</span>');

        // pdf
        //$('.section-content a[href$=".pdf"]').find('svg').remove();
        $('.section-content a[href$=".pdf"]').find('.linkarrow').remove();
        $('.section-content a[href$=".pdf"]').append('<svg class="icon-pdf"><use xlink:href="#pdf"></use></svg>');

        // mp3
        //$('.section-content a[href$=".mp3"]').find('svg').remove();
        $('.section-content a[href$=".mp3"]').find('.linkarrow').remove();
        $('.section-content a[href$=".mp3"]').append('<svg class="icon-audio"><use xlink:href="#audio"></use></svg>');

        // add video play svg to all youtube links
        $('a').each(function(){
          var _videoUrl = $(this).attr('href');
          if ( _videoUrl ) {
            var matches = _videoUrl.match(/watch\?v=([a-zA-Z0-9\-_]+)/);
            if (matches) {
              $(this).addClass('js-movie-yt');
              //$(this).find('svg').remove();
              $(this).find('.linkarrow').remove();
              $(this).append('<svg class="icon-play"><use xlink:href="#play_video"></use></svg>');
            }
          }
        });
        $('a').each(function(){
          var _videoUrl = $(this).attr('href');
          if ( _videoUrl ) {
            var matches = _videoUrl.match(/vimeo.com\/([a-zA-Z0-9\-_]+)/);
            if (matches) {
              $(this).addClass('js-movie-vimeo');
              //$(this).find('svg').remove();
              $(this).find('.linkarrow').remove();
              $(this).append('<svg class="icon-play"><use xlink:href="#play_video"></use></svg>');
            }
          }
        });

        // remove not needed svg
        $('a').has('img').find('.linkarrow').remove();
        $('.m3-team a').find('.linkarrow').remove();
        $('.breadcrumbs a').find('.linkarrow').remove();
        $('.link--clean, .link-clean').find('.linkarrow').remove();
        $('.link--clean, .link-clean').find('.icon-play').remove();


        // add img class to all image links
        $( 'a' ).has( 'img' ).addClass( 'link--img' );

        // open youtube videos
        $('.movie, .js-movie-yt').magnificPopup({
      		type: 'iframe',
      		iframe: {
            markup: '<div class="mfp-iframe-scaler">'+
                  '<div class="mfp-close"></div>'+
                  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                '</div>'/*,
      			patterns: {
      				youtube: {
      	                index: 'youtube.com/',
      	                id: 'v=',
      	                src: 'https://www.youtube.com/embed/%id%?rel=0&autoplay=1&showinfo=0'
      	            }
      			}*/
      		}
      	});
        $('.js-movie-vimeo').magnificPopup({
      		type: 'iframe',
      		iframe: {
            markup: '<div class="mfp-iframe-scaler">'+
                  '<div class="mfp-close"></div>'+
                  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                '</div>'/*,
      			patterns: {
      				youtube: {
      	                index: 'youtube.com/',
      	                id: 'v=',
      	                src: 'https://www.youtube.com/embed/%id%?rel=0&autoplay=1&showinfo=0'
      	            }
      			}*/
      		}
      	});
        $('.js-open-image').magnificPopup({type:'image'});
        $('.js-open-inline').magnificPopup({type:'inline'});

        $('.movie, .js-movie-yt, .js-movie-vimeo').on('click', function(e) {
          e.preventDefault();
        });
        // slider init
        $('.l-section-container--slider > .l-row').slick({
          draggable: false,
          arrows: true,
          infinite: true,
          mobileFirst: true,
          slidesToScroll: 1,
          dots: true,
          adaptiveHeight: false,
          prevArrow: '<a href="#" class="slick-prev"><svg class=""><use xlink:href="#slider-arrow" /></svg></a>',
          nextArrow: '<a href="#" class="slick-next"><svg class=""><use xlink:href="#slider-arrow" /></svg></a>',
        });

        $('.l-section-container--slider > .slider--blog').slick({
          draggable: false,
          arrows: true,
          infinite: true,
          mobileFirst: true,
          slidesToScroll: 1,
          dots: false,
          adaptiveHeight: false,
          prevArrow: '<a href="#" class="slick-prev"><svg class=""><use xlink:href="#slider-arrow" /></svg></a>',
          nextArrow: '<a href="#" class="slick-next"><svg class=""><use xlink:href="#slider-arrow" /></svg></a>',
        });


        // page menu
        /*if ($('.page-menu-container').length > 0) {
    			pageMenuTop = $('.page-menu-container').position().top;
    		}

        fixedPagemenu();*/
        $(window).trigger('resize').trigger('scroll');

        $('.menu-login').on('click ', function() {
    			ga('send', 'event', 'login', 'clicked');
    		});

    		$('.toggle-nav').on('click', toggleNav);
    		$('.close-panel').on('click', closeNav);

        $('.top-nav .menu-item-has-children > a, .lang-menu .menu-item-has-children > a').on('click', function(e) {
          e.preventDefault();
          $(this).parent().toggleClass('active');
        });

    		/*$('.toggle-nav-overlay').on('click', toggleNavOverlay);
    		$('.close-overlay').on('click', closeNavOverlay);
    		$('.nav-overlay').on('click', closeNavOverlay);
    		$('.nav-overlay > .l-inside').on('click', function(event) {
    		  event.stopPropagation();
    		});*/
        $('.ubermenu-item-level-0.ubermenu-item-has-children > a').each(function () {
          $(this).next().find('.ubermenu-retractor').text($(this).find('.ubermenu-target-title').text());
        })
    		$('.ubermenu-item-level-0.ubermenu-item-has-children > a').on('click touchstart ', function(e) {
          //e.preventDefault();
    			$('.main-nav').toggleClass('level-0-open');
          //e.stopPropagation();
    		});

    		$('.ubermenu-retractor').on('click touchstart ', function(e) {
          //e.preventDefault();
    			$('.main-nav').removeClass('level-0-open');
          //e.stopPropagation();
    		});
        $('.sub-menu__retractor').on('click touchstart ', function(e) {
          e.preventDefault();
    			$(this).parent().parent().removeClass('active');
          e.stopPropagation();
    		});


        // matchheight
        //$('.l-container--equal-height > .l-inside > div').matchHeight();
    		//$('.ubermenu-item-type-column > .ubermenu-submenu-type-stack').matchHeight();
    		$('.ubermenu-loc-footer-menu > ul > li').matchHeight();
        $('.pricing-row > td').matchHeight();
        $('.js-equal-height > *').matchHeight();


        // masonry post layout
        var $grid = $('#masonry');
        var selectorFilterValue = 'none';
        // If hash matches filter
        var setCat = window.location.hash.substring(1);
        if (setCat != "" && $('.masonry-filter a[href="#' + setCat + '"]').length ) {
          //selectorFilterValue = '.' + setCat;
          $('.masonry-filter a').removeClass('active');
          $('.masonry-selector a').addClass('active');
          $('.masonry-filter a[href="#' + setCat + '"]').addClass('active');
        }
        if (setCat != "" && $('.masonry-selector a[href="#' + setCat + '"]').length ) {
          //selectorFilterValue = '.' + setCat;
          $('.masonry-filter a').addClass('active');
          $('.masonry-selector a').removeClass('active');
          $('.masonry-selector a[href="#' + setCat + '"]').addClass('active');
          $('.masonry-selector').addClass('is-hidden');
        }
        if ($('.masonry-selector a.active').length) {
          var i = 0;
          $('.masonry-selector a').each(function() {
            if ( $(this).hasClass('active') ) {
              currentFilterElement = $(this);
              if ($('.masonry-filter a.active').length) {
                var j = 0;
                $('.masonry-filter a').each(function() {
                  if ( $(this).hasClass('active') ) {
                    selectorFilterValue += ', ' + $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                    j++;
                  }
                });
              } else {
                selectorFilterValue += ', ' + $(this).attr('data-filter');
              }
              i++;
            }
          });
        } else if ($('.masonry-filter a.active').length) {
          var i = 0;
          $('.masonry-filter a').each(function() {
            if ( $(this).hasClass('active') ) {
              currentFilterElement = $(this);
              if ($('.masonry-selector a.active').length) {
                var j = 0;
                $('.masonry-selector a').each(function() {
                  if ( $(this).hasClass('active') ) {
                    selectorFilterValue += ', ' + $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                    j++;
                  }
                });
              } else {
                selectorFilterValue += ', ' + $(this).attr('data-filter');
              }
              i++;
            }
          });
        }

        if ( $('#masonry').length != 0 ) {
          if ( $('.masonry-selector').length == 0 ) {
            if ( $('.masonry-filter').length == 0 ) {
              selectorFilterValue = '';
            }
          }
        }

        $grid.isotope({
          itemSelector: '.post-container',
          percentPosition: true,
          filterValue: selectorFilterValue,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        });
        $grid.isotope({ filter: selectorFilterValue });
        // layout Isotope after each image loads
        setTimeout(function(){
          //$('#masonry').imagesLoaded( function() {
            //console.log('imagesloaded');
            $grid.isotope('layout');
            //$grid.isotope({ filter: selectorFilterValue });
          //});
        }, 1000);


        // pots selector
        $('.masonry-selector a').on('click', function (e) {
          $(this).toggleClass('active');

          // reset Show all button status to active (remove below if conditions met)
          var is_all_active = true;
          // string to store active filter classes
          filterValue = '';
          var i = 0;
          $('.masonry-selector a:not(".all")').each(function() {

            currentFilterElement = $(this);
            // add active filters to filter value
            if ( currentFilterElement.hasClass('active') ) {
              if ( i == 0) {
                var j = 0;
                if ( $('.masonry-filter a.active').length ) {
                  $('.masonry-filter a').each(function() {
                    if ( $(this).hasClass('active') ) {
                      if ( j == 0) {
                        filterValue = $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                      } else {
                        filterValue += ', ' + $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                      }
                      j++;
                    }

                  });
                } else {
                  //if ( currentFilterElement.hasClass('active') ) {
                    filterValue = currentFilterElement.attr('data-filter');
                  //}
                }

              } else {
                if ( $('.masonry-filter a.active').length ) {
                  $('.masonry-filter a').each(function() {

                    if ( $(this).hasClass('active') ) {
                      filterValue += ', ' + $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                    }

                  });
                } else {
                  //if ( currentFilterElement.hasClass('active') ) {
                    filterValue += ', ' + currentFilterElement.attr('data-filter');
                  //}
                }

              }

              i++;
            } else {
              is_all_active = false;
            }
          });

          if (is_all_active) {
            $('.masonry-filter a.all').addClass('active');
            //$('.masonry-filter a.all').text('Show all');
          } else {
            $('.masonry-filter a.all').removeClass('active');

          }

          if ($('.masonry-filter a.active').length > 0) {
            $('.masonry-filter a.all').text('Piilota kaikki');
          } else {
            $('.masonry-filter a.all').text('Näytä kaikki');
            if ( $('.masonry-selector a').length ) {
              var j = 0;
              $('.masonry-selector a').each(function() {
                if ( $(this).hasClass('active') ) {
                  if ( j == 0) {
                    filterValue = $(this).attr('data-filter');
                  } else {
                    filterValue += ', ' + $(this).attr('data-filter');
                  }
                  j++;
                }

              });
            }
          }

          if ( $('.masonry-selector a').length && $('.masonry-selector a.active').length == 0) {
            filterValue = 'none';
          }

          $grid.isotope({ filter: filterValue });
          if ( $('.masonry-filter a.active').length == 0 && $('.masonry-selector a.active').length == 0 ) {
            $grid.isotope( 'hideItemElements', $('#masonry article') );
          }
          //console.log(filterValue);
          e.preventDefault();
        });


        // post filter
        $('.masonry-filter a').on('click', function (e) {
          // toggle all on or off when clickn Show All
          if ( $(this).hasClass('all') ) {
            if ($('.masonry-filter a.active').length == 0) {
              $('.masonry-filter a').addClass('active');
              //$('.masonry-selector a').addClass('active');
              $('.masonry-filter a.all').text('Piilota kaikki');
            } else {
              $('.masonry-filter a').removeClass('active');
              //$('.masonry-selector a').removeClass('active');
              $grid.isotope( 'hideItemElements', $('#masonry article') );
              $('.masonry-filter a.all').text('Näytä kaikki');
              return;
            }
          } else {
            // Toggle clicked element active class on or off
            if ( $('.masonry-filter a.active').length == $('.masonry-filter a').length) {
              $('.masonry-filter a').removeClass('active');
            }

          }
          $(this).toggleClass('active');
          // reset Show all button status to active (remove below if conditions met)
          var is_all_active = true;
          // string to store active filter classes
          filterValue = '';

          // if masonry selector is present, use it's value as base for filter
          /*if ($('.masonry-selector a.active').length) {
            var j = 0;

          }*/
          var i = 0;
          // loop through all filter buttons and see which are active
          $('.masonry-filter a:not(".all")').each(function() {

            currentFilterElement = $(this);
            // add active filters to filter value
            if ( currentFilterElement.hasClass('active') ) {
              if ( i == 0) {
                var j = 0;
                if ( $('.masonry-selector a.active').length ) {
                  $('.masonry-selector a').each(function() {
                    if ( $(this).hasClass('active') ) {
                      if ( j == 0) {
                        filterValue = $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                      } else {
                        filterValue += ', ' + $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                      }
                      j++;
                    }

                  });
                } else {

                  //if ( currentFilterElement.hasClass('active') ) {
                    filterValue = currentFilterElement.attr('data-filter');
                  //}
                }

              } else {
                if ( $('.masonry-selector a.active').length ) {
                  $('.masonry-selector a').each(function() {

                    if ( $(this).hasClass('active') ) {
                      filterValue += ', ' + $(this).attr('data-filter') + currentFilterElement.attr('data-filter');
                    }

                  });
                } else {
                  //if ( currentFilterElement.hasClass('active') ) {
                    filterValue += ', ' + currentFilterElement.attr('data-filter');
                  //}
                }

              }

              i++;
            } else {
              is_all_active = false;
            }


          });
          // if any of the filter buttons is not active, show all active class must be removed
          if (is_all_active) {
            $('.masonry-filter a.all').addClass('active');
            //$('.masonry-filter a.all').text('Show all');
          } else {
            $('.masonry-filter a.all').removeClass('active');
          }

          if ($('.masonry-filter a.active').length > 0) {
            $('.masonry-filter a.all').text('Piilota kaikki');
          } else {
            $('.masonry-filter a.all').text('Näytä kaikki');
            if ( $('.masonry-selector a').length ) {
              var j = 0;
              $('.masonry-selector a').each(function() {
                if ( $(this).hasClass('active') ) {
                  if ( j == 0) {
                    filterValue = $(this).attr('data-filter');
                  } else {
                    filterValue += ', ' + $(this).attr('data-filter');
                  }
                  j++;
                }

              });
            }
          }

          if ( $('.masonry-selector a').length && $('.masonry-selector a.active').length == 0) {
            //filterValue = 'none';
          }

          $grid.isotope({ filter: filterValue });
          if ($('.masonry-filter a.active').length == 0 && $('.masonry-selector a.active').length == 0 ) {
            $grid.isotope( 'hideItemElements', $('#masonry article') );
          }
          //console.log(filterValue);
          e.preventDefault();
        });


        // contactform
        var contactTrue = getUrlParameter('contact');
    		if ( contactTrue == 1) {
          if ($('.contactus a').length) {
              $.magnificPopup.open({
                  items: {
                      src: $('.contactus a').attr('href')
                  },
                  type: 'inline'
              });
          }
    			$('.formessage').remove();
    			$('.forminfo').hide();
    			$('#mail_form').show();
    		}
    		$('.contactus a').on('click',function(e) {
    			$('.formessage').remove();
    			$('.forminfo').hide();
    			$('#mail_form').show();
    			e.preventDefault();
    		});
    		$('.contactus a').magnificPopup({
          type:'inline',
          showCloseBtn: false
        });

        // open social sharing window
        $('.social-window').click(function (event) {
    			event.preventDefault();
    			window.open($(this).attr("href"), "popupWindow", "width=600,height=600,scrollbars=yes");
    		});



        $('[data-tabs-button="0"]').addClass('active');
        $('[data-tabs-content="0"]').addClass('visible');
        $('.tabs__sidecontent[data-tabs-content="0"]').addClass('animated-in');
        $('.tabs--accordion-changing-side [data-tabs-content="0"]').css('height', 'auto');
        $('.tabs--accordion-fixed-side [data-tabs-content="0"]').css('height', 'auto');
        //$('.tabs__button').parent().parent().parent().find('.tabs__content').removeClass('visible');
        //$('.tabs__button').parent().parent().parent().find('[data-tabs-content="'+$('.tabs__button.active').attr('data-tabs-button')+'"]').addClass('visible');

        $('.tabs__button').on('click', function() {
          var thisGroup = '.' + $(this).attr('data-tabs-group');
          $(thisGroup).find('.tabs__content').removeClass('visible');
          $(this).parent().find('.tabs__button').removeClass('active');
          $(this).addClass('active');
          $(thisGroup).find('[data-tabs-content="'+$(this).attr('data-tabs-button')+'"]').addClass('visible');

          // Horizontal
          //if ( $(this).parent().parent().parent().hasClass('tabs--horizontal') ) {
            $(thisGroup).find('.tabs__container').css('height', $(thisGroup).find('[data-tabs-content="'+$(this).attr('data-tabs-button')+'"]').height());
            $(thisGroup).find('.tab-indicator').css('left', $(this).position().left).css('width', $(this).outerWidth());
          //}
          // Change mobile select value
          $(thisGroup).find('.tabs__select').val( $(this).attr('data-tabs-button') );
        });
        function tabIndicatorSizes() {
          if ( $('.tab-indicator').length ) {
            $('.tab-indicator').each(function() {
               $(this).css('left', $(this).parent().find('.tabs__button.active').position().left).css('width', $(this).parent().find('.tabs__button.active').outerWidth());
            });
          }

        }
        tabIndicatorSizes();




        $('.tabs__accordion-open').on('click', function() {
          var thisGroup = '.' + $(this).attr('data-tabs-group');
          var thisTabContent = $(thisGroup).find('.tabs__content[data-tabs-content="'+$(this).attr('data-tabs-button')+'"]');
          var thisTabSideContent = $(thisGroup).find('.tabs__sidecontent[data-tabs-content="'+$(this).attr('data-tabs-button')+'"]');

          // Close all and remove active
          $(thisGroup).find('.tabs__content').removeClass('visible');
          $(thisGroup).find('.tabs__content').css('height', 0);

          // Set all previous and next accordions closed
          $(this).prevAll().removeClass('active');
          $(this).nextAll().removeClass('active');

          // Open or close clicked accordion
          $(this).toggleClass('active');

          // Side content animate in/out
          $(thisGroup).find('.tabs__sidecontent').removeClass('animated-in');
          setTimeout(function(){
            $(thisGroup).find('.tabs__sidecontent').removeClass('visible');
          }, 300);

          // Open only if clicked accordion is active
          if ( $(this).hasClass('active') ) {
            thisTabContent.addClass('visible');
            thisTabContent.css('height', thisTabContent.attr('data-height'));
            setTimeout(function(){
              thisTabSideContent.addClass('visible');
              thisTabSideContent.addClass('animated-in');
            }, 301);
          }

        });

        $('.tabs__select').on('change', function() {
          var thisGroup = '.' + $(this).attr('data-tabs-group');
          $(thisGroup).find('.tabs__content').removeClass('visible');
          //$('.tabs__button').removeClass('active');
          //$(this).addClass('active');
          $(thisGroup).find('[data-tabs-content="'+$(this).val()+'"]').addClass('visible');

          // Change desktop select value only for horizontal
          if ( $(thisGroup).find('.tabs__button').length ) {
            $(thisGroup).find('.tabs__button[data-tabs-button="' + $(this).val() + '"]').click();
            /*$(thisGroup).find('.tabs__button').removeClass('active');
            $(thisGroup).find('.tabs__button[data-tabs-button="' + $(this).val() + '"]').addClass('active');
            tabIndicatorSizes();*/
          }

        });

        function accordionSizes() {
          $('.tabs--accordion-changing-side .tabs__content').each(function() {
            $(this).attr('data-height', $(this).find('.l-row').height() + 'px');
          })
          $('.tabs--accordion-fixed-side .tabs__content').each(function() {
            $(this).attr('data-height', $(this).find('.l-row').height() + 'px');
          })
        }
        accordionSizes();


        $(window).on('breakpoint-change', function(e, breakpoint) {

      		if ( breakpoint === 'break-0' || breakpoint === 'break-1' ) {
            //$('.main-nav').height($(window).height());
      		}

      		if ( breakpoint === 'break-2' || breakpoint === 'break-3' || breakpoint === 'break-4' ) {
            //$('.main-nav').css('height', 'auto');
            $('body').css('overflow-y', 'auto');
            $('.main-nav').removeClass('open');
      		}

      	});

        // parallax effect
        $(window).scroll(function () {

          window.requestAnimationFrame(function() {

            $('.l-section-container--parallax .parallax-bg').css({
              'transform':    'translate3d(' + '0px, ' + $(window).scrollTop() / 2 + 'px, 0)'
            });
          });
        });

        debounce = function(func, wait, immediate) {
      	    var timeout;
      	    return function() {
      	        var context = this, args = arguments;
      	        clearTimeout(timeout);
      	        timeout = setTimeout(function() {
      	            timeout = null;
      	            if (!immediate) func.apply(context, args);
      	        }, wait);
      	        if (immediate && !timeout) func.apply(context, args);
      	    };
      	};

        var windowW = $(window).width();
        var lastScrollTop = 0;
        var scrollDelta = 1;

        function fixHeader() {
          st = $(window).scrollTop();
          //console.log($('.header').position().top);

          if ( windowW >= 900 ) {

            if ( ( $('body').hasClass('has-top-nav') && st > 28 ) || (!$('body').hasClass('has-top-nav') && st > 0) ) {
              $('.header').css('marginTop', 0 );
              $('.has-top-nav .header').css('marginTop', -28 );
        		} else {
              $('.header').css('marginTop', st * -1 );
        		}
            if ( st > 112 ) {
              $('body').addClass('scrolled');
            } else {
              $('body').removeClass('scrolled');
            }
          }
          if ( ( $('body').hasClass('has-top-nav') && st > 28 ) || (!$('body').hasClass('has-top-nav') && st > 0) ) {
            if ( st > lastScrollTop && $('.header').position().top > -84 ) {
              scrollDelta = st - lastScrollTop;
              $('.header').css('top', $('.header').position().top - scrollDelta );
              $('.header').removeClass('in-view');
            } else if ( st > lastScrollTop ) {
              $('.header').css('top', -84 );
              $('.header').removeClass('in-view');
            }
            if ( st < lastScrollTop && $('.header').position().top < 0 ) {
              scrollDelta = lastScrollTop - st;
              /*if ( scrollDelta > $('.header').position().top * -1 ) {
                scrollDelta = $('.header').position().top;
              }*/
              $('.header').addClass('in-view');
              $('.header').css('top', $('.header').position().top + scrollDelta );
              if ( $('.header').position().top > 0 ) {
                $('.header').css('top', 0 );

              }
            } else if ( st < lastScrollTop ) {
              $('.header').addClass('in-view');
              $('.header').css('top', 0 );
            }
          }
          if ( st == 0 ) {
            $('.header').removeClass('in-view');
          }



          /*if(st < lastScrollTop) {
              console.log('up 1');
          }
          else {
              console.log('down 1');
          }*/
          lastScrollTop = st;
        }

        // debounced resize event
      	var resizeDebounce = debounce(function() {
          windowW = $(window).width();
          accordionSizes();
          tabIndicatorSizes();
      	}, 100);
      	window.addEventListener('resize', resizeDebounce);


      	// scroll function
      	/*var scrollDebounce = debounce(function() {
          fixedHeader();
      		//fixedPagemenu();
      		if ($('.js-scrolltrigger').length) {
      			$('.js-scrolltrigger').each(function() {
      				if ( $(window).scrollTop() > $(this).offset().top - $(window).height()*0.7 ) {
      					$(this).addClass('scrolled-in-view');
      				}
      			});

      		}

      	}, 1);
      	window.addEventListener('scroll', scrollDebounce);*/

        fixHeader();
        if ( $('.header').position().top < -84 ) {
          $('.header').css('top', -84 );
        }
        $(window).on('scroll', function() {
          fixHeader();
        });





      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
